/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const IconlyLightOutlineArrowDown21 = ({
  color = "white",
  className,
}) => {
  return (
    <svg
      className={`iconly-light-outline-arrow-down-2-1 ${className}`}
      fill="none"
      height="19"
      viewBox="0 0 18 19"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M5.97725 15.3509C5.77755 15.1512 5.7594 14.8387 5.92279 14.6185L5.97725 14.5554L10.8293 9.70312L5.97725 4.85087C5.77755 4.65117 5.7594 4.33867 5.92279 4.11847L5.97725 4.05538C6.17695 3.85568 6.48945 3.83752 6.70966 4.00091L6.77275 4.05538L12.0227 9.30538C12.2224 9.50508 12.2406 9.81758 12.0772 10.0378L12.0227 10.1009L6.77275 15.3509C6.55308 15.5705 6.19692 15.5705 5.97725 15.3509Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

IconlyLightOutlineArrowDown21.propTypes = {
  color: PropTypes.string,
};
